import { createSlice } from '@reduxjs/toolkit';
import { getUserType, hasSession } from '../_helpers/session';
import { userConstants } from '../_constants';

export function createAuthenticationState() {
  return {
    loggedIn: hasSession(),
    userType: getUserType(),
    user: null,
    isLoading: false,
    loggingIn: false,
    error: null,
  };
}

function loggedOutState() {
  return {
    ...createAuthenticationState(),
    loggedIn: false,
    userType: null,
  };
}

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState: createAuthenticationState(),
  reducers: {
    request(state, action) {
      state.isLoading = true;
      state.loggingIn = true;
      state.user = action.payload;
      state.error = null;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    success(state, action) {
      state.loggedIn = true;
      state.loggingIn = false;
      state.userType = action.payload;
      state.error = null;
    },
    failure(state, action) {
      state.loggedIn = false;
      state.loggingIn = false;
      state.userType = null;
      state.user = null;
      state.error = action.payload;
    },
    logout: loggedOutState,
  },
  extraReducers: (builder) => {
    builder.addCase(userConstants.LOGOUT, loggedOutState);
  },
});

export const authenticationActions = authenticationSlice.actions;
export default authenticationSlice.reducer;
